const postfooter = {
    color: `omegaDark`,
    textDecoration: `none`,
    userSelect: `none`,
    ':hover': {
      color: 'alpha'
    },
    cursor: `pointer`,
    svg: {
        verticalAlign: `middle`,
        display: `inline-block`,
        mr: 2,
        mb: 0
      }
  }
  
  export default postfooter